module.exports = __webpack_public_path__ + "img/setup-init.429b5860.svg";